// Contraste texte noir/blanc calculé par luminance perçue, pour rester lisible
// sur une couleur de fond arbitraire (couleur de statut atelier, etc.).
export function getContrastColor(hex) {
  if (!hex || hex.length < 7) return '#000000';
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) > 160 ? '#000000' : '#ffffff';
}
